"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.asyncWrapper = exports.runAsync = void 0;
/**
 * A function that runs the given async functions and catches errors
 */
function runAsync(asyncF, onError) {
    if (onError === void 0) { onError = console.error; }
    asyncF().catch(onError);
}
exports.runAsync = runAsync;
/**
 * A function that runs the given async functions and catches errors
 */
function asyncWrapper(asyncF, onError) {
    if (onError === void 0) { onError = console.error; }
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        asyncF.apply(void 0, args).catch(onError);
    };
}
exports.asyncWrapper = asyncWrapper;
//# sourceMappingURL=async.js.map